import api from '@pray/shared/utils/api';

import type { UpdateSlideResponse } from './data/response';
import type { UpdateSlideRequest } from './data/types';

type UpdateSlideProps = {
  artistId: string;
  reportId: string;
  slideId: string;
  data: UpdateSlideRequest;
};

export async function updateSlide({
  artistId,
  reportId,
  slideId,
  data,
}: UpdateSlideProps): Promise<UpdateSlideResponse> {
  if (!artistId) throw new Error('Artist ID is required');
  if (!reportId) throw new Error('Report ID is required');
  if (!slideId) throw new Error('Slide ID is required');

  const url = `/web/studio/artists/${artistId}/reports/${reportId}/slides/${slideId}`;

  const response = await api.executePatchRequest<UpdateSlideResponse>(url, data);
  return response.data;
}
